var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 23.336,
    viewBox: "0 0 32 23.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2266.001 7252.18) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7252.18 2234.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.978,426.667c-7.184,0-11.646,1.023-11.646,2.667a.947.947,0,0,0,.1.392,1.2,1.2,0,0,0,.068.127,1.466,1.466,0,0,0,.208.251,1.994,1.994,0,0,0,.215.183,2.7,2.7,0,0,0,.3.2c.064.037.137.073.208.111a5.753,5.753,0,0,0,.543.241l.013.005c2.577.957,7.425,1.121,9.309,1.149.227,0,.45.008.681.008s.454,0,.68-.007c1.884-.028,6.733-.192,9.309-1.149l.015-.005a5.327,5.327,0,0,0,.543-.241c.071-.036.143-.073.208-.111a3.114,3.114,0,0,0,.3-.2,2.332,2.332,0,0,0,.215-.183,1.389,1.389,0,0,0,.208-.251,1.2,1.2,0,0,0,.068-.127.937.937,0,0,0,.1-.393C108.624,427.69,104.162,426.667,96.978,426.667Z",
    transform: "translate(-85.333 -400)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.384,3.455h0A1.092,1.092,0,0,1,0,2.667a.612.612,0,0,1,.071-.28A1.44,1.44,0,0,1,.63,1.692a4.475,4.475,0,0,1,1.081-.545A15.938,15.938,0,0,1,4.857.434C5.881.289,7.053.177,8.342.1,9.436.038,10.389.014,11,.005l.258,0h0l.388,0,.392,0,.256,0c.606.009,1.559.033,2.655.1,1.288.075,2.46.187,3.484.333a15.949,15.949,0,0,1,3.146.713,4.476,4.476,0,0,1,1.081.545,1.44,1.44,0,0,1,.559.694.6.6,0,0,1,.073.28,1.092,1.092,0,0,1-.384.788,4.075,4.075,0,0,0-1.439-.79,14.517,14.517,0,0,0-2.418-.591c-.963-.162-2.075-.286-3.305-.37-1.251-.085-2.63-.128-4.1-.128s-2.848.043-4.1.128c-1.23.084-2.342.208-3.305.37a14.517,14.517,0,0,0-2.418.591,4.075,4.075,0,0,0-1.439.79Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.333,77.888v22.264q2.917-1.79,11.645-1.8t11.646,1.8V77.888q-2.915,1.79-11.646,1.8T85.333,77.888Z",
    transform: "translate(-85.333 -73.02)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-7252.18,2533.346v11.04h23.336v-6.959Z",
    transform: "translate(0 -280.636)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTube);
export default __webpack_public_path__ + "static/media/tube.810174380a2af9d314dfaafde95dd348.svg";
export { ForwardRef as ReactComponent };